/* eslint-disable react-hooks/exhaustive-deps */
import { 
    Button, 
    CardContent,
    Grid, 
    Paper, 
    Typography, 
    Theme, 
    useTheme,
    Box,
    Modal,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import MyTable, { TableRow } from "../../../components/MyTable";
  import { TableHeadRows } from "../../../components/MyTable/TableHead";
  import MySnackbar from "../../../components/MySnackbar";
  import { getInMyChargeAttendances } from "../../../api/s10OrganizationApi";
  import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getDatestring } from "../../../utils/date";
import { signedDownloadUrl } from "../../../api/fileStorage";
  
interface Attendance {
    AttendaceMarkId: number;
    EmployeeId: number;
    DeviceName: string;
    FullName: string;
    Code: string;
    DocumentNumber: string;
    DateTimeShift: string;
    DateTimeWorkShift: string;
    DateTimeMark: string;
    AuthenticationType: string;
    MarkType: string;
    IPAddress: string;
    Longitude: number | null;
    Latitude: number | null;
    CompanyCode: string;
    CompanyDescription: string;
    ProjectDescription: string;
    EmployeeRegimeDescription: string;
    PhotoKey: string;
}

const AttendanceCard = (
  row: Attendance, 
  theme: Theme, 
  onViewLocation: (attendance: Attendance) => void, 
  setSnackBarMessage: any,
  setImageUrl: any,
  setImageLoading: any,
  imageLoading: boolean
) => {
  const isEntrance = row.MarkType.toLowerCase().includes("entrada");
  

  const seeAttendanceImage = async () => {
    if (imageLoading) return;
    setImageLoading(true);
    
    const ruc = row.PhotoKey.split('/')[0];
    const result = await signedDownloadUrl(ruc, [{Key: row.PhotoKey}]);
    
    if (result?.Type === 0 && result.Value?.length && result.Value[0].Presigned_url) {
      setImageUrl(result.Value[0].Presigned_url);
    } else {
      setSnackBarMessage({
        success: false,
        msg: result?.Message || 'Error al cargar la imagen'
      });
    }
    setImageLoading(false);
  }
  return (
      <CardContent key={row.AttendaceMarkId} style={{ padding: "1rem", position: 'relative' }}>
          <Grid container spacing={1}>
              <Grid item xs={12}>
                  <Typography variant="h6" component="div">
                      {row.FullName.trim()}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Código:</strong> {row.Code}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Documento:</strong> {row.DocumentNumber}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Fecha:</strong> {getDatestring(row.DateTimeWorkShift, '-', false)}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Hora:</strong> {row.DateTimeMark}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Tipo:</strong> 
                      <span style={{
                      color: isEntrance 
                          ? theme.s10palette?.S10Greengreen500 || '#4caf50' 
                          : theme.s10palette?.S10Redred500 || '#f44336',
                      fontWeight: 'bold',
                      marginLeft: '4px'
                      }}>
                      {row.MarkType}
                      </span>
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Dispositivo:</strong> {row.DeviceName}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>IP:</strong> {row.IPAddress || 'No registrada'}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Empresa:</strong> {row.CompanyDescription}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Proyecto:</strong> {row.ProjectDescription}
                  </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.primary">
                      <strong>Régimen:</strong> {row.EmployeeRegimeDescription}
                  </Typography>
              </Grid>
              
              {row.Latitude && row.Longitude && (
                  <Grid item xs={6}>
                      <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid #e0e0e0' }}>
                          <Button
                              variant="outlined"
                              size="small"
                              startIcon={<LocationOnIcon />}
                              onClick={() => onViewLocation(row)}
                              sx={{ mt: 0.5 }}
                          >
                              Ver Ubicación
                          </Button>
                      </Box>
                  </Grid>
              )}
              {row.PhotoKey && (
                  <Grid item xs={6}>
                      <Box sx={{ mt: 1, pt: 1, borderTop: '1px solid #e0e0e0' }}>
                          <Button
                              variant="outlined"
                              size="small"
                              startIcon={<LocationOnIcon />}
                              onClick={seeAttendanceImage}
                              disabled={imageLoading}
                              sx={{ mt: 0.5 }}
                          >
                              {imageLoading ? 'Cargando...' : 'Ver foto'}
                          </Button>
                      </Box>
                  </Grid>
              )}
          </Grid>
      </CardContent>
  );
};
  
const AttendanceConsultView = () => {
    const theme = useTheme();
    
    const { companyselected, connectionId } = useSelector((state: RootState) => state.auth);
    const [attendances, setAttendances] = useState<Attendance[]>([]);
    const [filteredAttendances, setFilteredAttendances] = useState<Attendance[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [snackBarMessage, setSnackBarMessage] = useState<any | undefined>();
    const [markTypeFilter, setMarkTypeFilter] = useState<string>("all");
    const [searchValue, setSearchValue] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | null>(() => {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return date;
    });
    const [endDate, setEndDate] = useState<Date | null>(new Date());
    const [locationModalOpen, setLocationModalOpen] = useState<boolean>(false);
    const [selectedAttendance, setSelectedAttendance] = useState<Attendance | null>(null);
    const [imageUrl, setImageUrl] = useState('');
    const [imageLoading, setImageLoading] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    
    const attendanceHeader = [
      {
        label: "Empleado",
        rowKeyName: "FullName",
      },
      {
        label: "Código",
        rowKeyName: "Code",
      },
      {
        label: "Documento",
        rowKeyName: "DocumentNumber",
      },
      {
        label: "Fecha",
        rowKeyName: "DateTimeWorkShift",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
          return new Date(row.DateTimeWorkShift).toLocaleDateString();
        },
      },
      {
        label: "Hora",
        rowKeyName: "DateTimeMark",
      },
      {
        label: "Tipo",
        rowKeyName: "MarkType",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
          const isEntrance = row.MarkType.toLowerCase().includes("entrada");
          return (
            <span style={{
              color: isEntrance ? '#4caf50' : '#f44336',
              fontWeight: 'bold'
            }}>
              {row.MarkType}
            </span>
          );
        },
      },
      {
        label: "IP",
        rowKeyName: "IPAddress",
      },
      {
        label: "Dispositivo",
        rowKeyName: "DeviceName",
      },
      {
        label: "Ubicación",
        rowKeyName: "googleMapUrl",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
          if (!row.Latitude || !row.Longitude) {
            return "No disponible";
          }
          return (
            <Button
              variant="outlined"
              size="small"
              startIcon={<LocationOnIcon />}
              onClick={() => handleViewLocation(row as any)}
            >
              Ver
            </Button>
          );
        },
      },
    ];

    useEffect(() => {
        if (!startDate || !endDate || loading || !connectionId || !companyselected) {
            return;
        }
        console.log('*********')
        fetchAttendances();
    }, [endDate, companyselected, connectionId])
  
    const handleViewLocation = (attendance: Attendance) => {
      setSelectedAttendance(attendance);
      setLocationModalOpen(true);
    };
  
    const handleCloseLocationModal = () => {
      setLocationModalOpen(false);
      setSelectedAttendance(null);
    };
  
    const openGoogleMaps = () => {
      if (selectedAttendance?.Latitude && selectedAttendance?.Longitude) {
        window.open(
          `https://www.google.com/maps?q=${selectedAttendance.Latitude},${selectedAttendance.Longitude}&z=17`,
          "_blank"
        );
      }
    };
  
    const formatDateForApi = (date: Date): string => {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
  
    const fetchAttendances = async () => {  
      if ((!startDate || !endDate) || startDate > endDate) {
        setSnackBarMessage({
          success: false,
          msg: "Debes seleccionar un rango de fechas válido"
        });
        return;
      }
  
      setLoading(true);
      try {
        const startTime = formatDateForApi(startDate);
        const endTime = formatDateForApi(endDate);
        
        const response = await getInMyChargeAttendances(startTime, endTime);
        setFilteredAttendances([])
        
        if (response.data && Array.isArray(response.data)) {
          const finalData = response.data.map((a: any) => ({
                ...a,
                googleMapUrl: `https://www.google.com/maps?q=${a.Latitude},${a.Longitude}&z=17`
            }));
          setAttendances(finalData)
          setFilteredAttendances(finalData.filter((a: any) => isValidMark(a, markTypeFilter)))
            
          if (filteredAttendances.length === 0) {
              setSnackBarMessage({
                  success: true,
                  msg: "No se encontraron marcaciones para los filtros seleccionados"
              });
          }
        } else {
          setAttendances([]);
          setSnackBarMessage({
            success: false,
            msg: "Error al obtener las marcaciones"
          });
        }
      } catch (error) {
        console.error("Error fetching attendances:", error);
        setSnackBarMessage({
          success: false,
          msg: "Error al conectar con el servidor"
        });
        setAttendances([]);
      } finally {
        setLoading(false);
      }
    };

    const isValidMark = (attendance: Attendance, selectedMark: string) =>  selectedMark === 'all' || attendance.MarkType === selectedMark
  
    useEffect(() => {
      console.log('---- attendances[0]', attendances[0]?.MarkType, markTypeFilter)
      setFilteredAttendances([])
      if (!searchValue) {
        setFilteredAttendances(attendances.filter(a => isValidMark(a, markTypeFilter)))
      } else {
        setFilteredAttendances(attendances.filter(a => a.FullName.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()) && isValidMark(a, markTypeFilter)))
      }
    }, [searchValue, markTypeFilter, itemsPerPage]);
  
    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >
            
            <MyTable
                key={`attendance-table`}
                tableHeadRows={attendanceHeader}
                tableRows={filteredAttendances}
                onChangeItemsPerPage={setItemsPerPage}
                cardComponent={{
                    cardContent: (row) => AttendanceCard(
                      row as Attendance, 
                      theme, 
                      handleViewLocation,
                      setSnackBarMessage,
                      setImageUrl,
                      setImageLoading,
                      imageLoading
                    ),
                }}
                searchInputString={searchValue}
                onChangeSearchInputString={setSearchValue}
                rangeControlProps={{
                    startDate: startDate,
                    endDate: endDate,
                    setEndDate: setEndDate,
                    setStartDate: setStartDate,
                }}
                customItemOptionBarMiddle={() =>
                    <Grid item > 
                        <FormControl style={{width: "100%"}}>
                            <InputLabel id="select-option-label">Tipo</InputLabel>
                            <Select
                                labelId="select-option-label"
                                id="select-option"
                                label="Tipo"
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setMarkTypeFilter(value)
                                }}
                                value={markTypeFilter}
                                style={{height: "2.5rem", minWidth: '8rem', border: "none", backgroundColor: "white"}}
                            >
                                <MenuItem value={"all"}>
                                    Todos
                                </MenuItem>
                                <MenuItem value={"Entrada"}>
                                    Entrada
                                </MenuItem>
                                <MenuItem value={"Salida"}>
                                    Salida
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                }
                loading={loading}
                tableOptionsBar={{
                    useDrawer: false,
                }}
            />
            </Paper>
            
            {locationModalOpen && <Modal
                open={locationModalOpen}
                onClose={handleCloseLocationModal}
                aria-labelledby="location-modal-title"
                aria-describedby="location-modal-description"
            >
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 800,
                    height: "80%",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 0,
                    borderRadius: 1,
                    overflow: "hidden"
                }}>
                    {selectedAttendance && (
                    <>
                        <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}>
                        <Typography id="location-modal-title" variant="h6">
                            Ubicación de Marcación
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {selectedAttendance.FullName.trim()} - {selectedAttendance.DateTimeWorkShift} {selectedAttendance.DateTimeMark}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Latitud: {selectedAttendance.Latitude?.toFixed(6)}, Longitud: {selectedAttendance.Longitude?.toFixed(6)}
                        </Typography>
                        </Box>
                        <Box sx={{ width: '100%', minHeight: 'calc(100% - 150px)', height: 'calc(100% - 150px)' }}>
                        <iframe
                            title="OpenStreetMap"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${selectedAttendance.Longitude! - 0.01},${selectedAttendance.Latitude! - 0.01},${selectedAttendance.Longitude! + 0.01},${selectedAttendance.Latitude! + 0.01}&layer=mapnik&marker=${selectedAttendance.Latitude},${selectedAttendance.Longitude}`}
                            allowFullScreen
                        />
                        </Box>
                        <Box sx={{ p: 2, textAlign: "center", borderTop: 1, borderColor: "divider" }}>
                        <Button
                            variant="outlined"
                            onClick={openGoogleMaps}
                            sx={{ mr: 2 }}
                        >
                            Abrir en Google Maps
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleCloseLocationModal}
                        >
                            Cerrar
                        </Button>
                        </Box>
                    </>
                    )}
                </Box>
            </Modal>}
            
            {imageUrl && <Modal
                open={true}
                onClose={() => setImageUrl('')}
                aria-labelledby="image-modal-title"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    maxHeight: '90%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: 1,
                    overflow: 'hidden',
                    outline: 'none'
                }}>
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                        <img 
                            src={imageUrl} 
                            alt="Foto de asistencia"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '70vh',
                                objectFit: 'contain'
                            }}
                        />
                    </Box>
                    <Box sx={{ p: 2, textAlign: 'center', borderTop: 1, borderColor: 'divider' }}>
                        <Button
                            variant="contained"
                            onClick={() => setImageUrl('')}
                        >
                            Cerrar
                        </Button>
                    </Box>
                </Box>
            </Modal>}
            
            {snackBarMessage && (
                <MySnackbar 
                    msg={snackBarMessage.msg} 
                    severity={snackBarMessage.success ? 'success' : 'error'}
                    onClose={() => setSnackBarMessage(undefined)}
                    open={true}
                />
            )}
        </Grid>
    );
};
  
export default AttendanceConsultView;